module.exports = __webpack_public_path__ + "img/despacho-bins.d174d7f6.png";